// @flow
import type { $Response } from 'express';
import moment from 'moment';
import { windowWrapper } from '@clubmed/utils';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';

import {
  buildSigninUrl,
  buildErrorUrl,
  buildSellerSigninUrl,
  isCxoSellerContext,
  QUICK_LOGIN_QUERY_PARAM,
} from './index';

type HandleInvalidTokenParams = {
  appContext: AppContext,
  currentUri: URI,
  res: ?$Response,
  userInfo: ?UserInfo,
};
export const handleInvalidToken = ({
  appContext,
  currentUri,
  res,
  userInfo,
}: HandleInvalidTokenParams) => {
  const redirectUri = isCxoSellerContext(currentUri.search())
    ? buildSellerSigninUrl({
        locale: appContext.locale,
        redirectUri: currentUri.toString(),
        redirectURIError: buildErrorUrl(currentUri.toString(), appContext.locale),
      })
    : buildSigninUrl({
        locale: appContext.locale,
        redirectUri: currentUri.toString(),
        redirectURIError: buildErrorUrl(currentUri.toString(), appContext.locale),
        isQuickLoginFirst:
          currentUri.toString().includes(`provider=${QUICK_LOGIN_QUERY_PARAM}`) ||
          isFeatureFlipped(appContext)('memberSpace.isQuickLoginFirst'),
      });
  // not filled because the cookie is httpOnly
  // if (!appContext.authenticationToken) {
  if (!appContext.isUserLogged && !appContext.isUserQuickLogged && !appContext.isSellerLogged) {
    if (res) {
      res.redirect(302, redirectUri);
    } else {
      windowWrapper.setLocation(redirectUri);
    }
  } else {
    const isTokenValid =
      userInfo &&
      moment(userInfo.expirationDate, 'X')
        .startOf('second')
        .isAfter();

    if ((appContext.isUserLogged || appContext.isUserQuickLogged) && !isTokenValid) {
      windowWrapper.setLocation(redirectUri);
    }
  }
};
